import { Injectable, OnInit } from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class ValidationService {
  private hhmmRegex = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
  private emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  validateEmail(email: string) {
    return email && this.emailRegex.test(String(email).toLowerCase());
  }

  validateNumber(number: any) {
    return !isNaN(+number);
  }

  validateHHmm(time: string) {
    return this.hhmmRegex.test(time);
  }

  validateZabrane(spot, rasporedi: any[]): boolean {
    if (spot.Zabrane.length) {
      const zabrana = Math.min(
        ...spot.Zabrane.map(
          z =>
            new Date(
              2000,
              1,
              1,
              z.Vreme.split(':')[0],
              z.Vreme.split(':')[1],
              0,
              0
            )
        )
      );

      return rasporedi.every(r => {
        const rasporedDateTime = this.getDateTime(r);
        const pocetakZabrane = this.get06h(r.DatumEmitovanja);
        const krajZabrane = moment(zabrana)
          .set('year', rasporedDateTime.year())
          .set('month', rasporedDateTime.month())
          .set('date', rasporedDateTime.date());
        const isAfter = rasporedDateTime.isSameOrAfter(moment(pocetakZabrane));
        const isBefore = rasporedDateTime.isBefore(krajZabrane);

        return !(isAfter && isBefore);
      });
    } else {
      return true;
    }
  }

  private getDateTime(raspored): moment.Moment {
    const datumStr = raspored.DatumEmitovanja.substring(0, 10);
    let hhStr = raspored.VremeEmitovanja.split(':')[0];
    const mmStr = raspored.VremeEmitovanja.split(':')[1];

    const date = moment(datumStr, 'YYYY-MM-DD');
    const offset1 = date.utcOffset() / 60;
    let dateTime = date.add(+hhStr, 'hours').add(+mmStr, 'minutes');
    const offset2 = date.utcOffset() / 60;
    if (offset1 < offset2) {
      dateTime = date.add(-(offset2 - offset1), 'hours');
    } else if (offset1 > offset2) {
      dateTime = date.add(+(offset1 - offset2), 'hours');
    }

    return dateTime;
  }

  private get06h(datum: string): moment.Moment {
    const datumString = datum.substring(0, 10);
    const datumMoment = moment(datumString, 'YYYY-MM-DD').add(6, 'hours');

    return datumMoment;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/validation.service.ts